import { Model } from '@/models/Model';
export class Holiday extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Holiday';
        this.$endpoint = '/holidays';
        this.$fillable = ['title', 'starts_at', 'ends_at'];
    }
    get backgroundEvent() {
        const parsedEvent = {
            start: this.starts_at || '',
            end: this.ends_at || '',
            rendering: 'background',
            title: this.title || '',
            allDay: true,
        };
        return parsedEvent;
    }
}
